/**
 * Skus Inventory
 */

// React
import React, { FunctionComponent, useEffect, useState, useContext, Props } from 'react';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../redux/reducers';

// Selector
import { createStructuredSelector } from 'reselect';

// Components
import Pagination from '@material-ui/lab/Pagination';
import ExelExport from './components/exelExport';
import List from './components/list';

// UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  CircularProgress,
  Button,
  Grid,
  FormControl,
  Select,
  MenuItem,
  Paper,
  IconButton,
  Card,
  CardHeader,
  CardContent,
  Grow,
  Popper,
  MenuList,
  ClickAwayListener,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
  TextField,
} from '@material-ui/core';

// Helper
import {
  flattenObject,
  removeEmptyValueObject,
  checkMatchMedia,
  convertPersianDigit2English,
  skipDateByDay,
  maxDate,
  disablePrevDateByHour,
} from '../../utils/helpers';
import skuRepository from 'client-sdk/src/Repository/skus-repository';
import {
  getOrdersAction,
  updateOrderStatusActions,
  updateAllOrderStatusActions,
  actionRetrieveRubikaOrdersAction,
  cancelOrderAction,
  getAllOrdersReportAction,
  resendOrdersAction,
} from '../orders/actions';

// Selector
// import {createStructuredSelector} from 'reselect';
import {
  makeSelectOrdersList,
  makeSelectLoading,
  makeSelectError,
  makeSelectCountList,
} from '../orders/selectors';
// Type
import Icon from '@mdi/react';
import { mdiArchiveOutline, mdiKeyOutline, mdiMenuDown, mdiClose, mdiAccountOutline, mdiPhoneOutline, mdiAccountKeyOutline, mdiCalendar, mdiHomeCityOutline, mdiHomeSearchOutline, mdiPackageVariant, mdiStateMachine } from '@mdi/js';
import Can from '../../components/Can';
import AuthContext from '../../authContext';
import { Payload, SelectorProps, SkuInventory } from '../warehouses/interfaces';
import useQuery from '../../utils/hook/useQuery';
import windowSize from '../../utils/hook/useWindowResize';
import RenderFilter, { Filter } from '../../utils/listDaynamicFilterHookForm';
import ReturnList from './components/returnList';
import ResendList from './components/resendList';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import JalaliUtils from '@date-io/jalaali';
import { Controller, useForm } from 'react-hook-form';
import { PayloadAllUpdate } from '../orders/interfaces';
import { cancelPayload } from '../users/interfaces';
// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    paper: {
      position: 'relative',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '30vh',
      minWidth: '50vw',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    box: {
      display: 'flex',
      backgroundColor: '#fff',
      padding: theme.spacing(2, 3),
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    boxIcon: {
      // display: 'flex',
      // alignItems: 'center',
      marginRight: '30px',
    },
    allCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#B297A7',
      },
    },
    activeCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#039590',
      },
    },

    title: {
      display: 'flex',
      alignItems: 'center',
      color: '#8A8A8A',
      fontSize: '16px',
      fontWeight: 500,
      marginRight: '8px',
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '21px',
      fontWeight: 500,
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      padding: '10px 0',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },

    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      marginRight: '10px',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: '0',
      marginTop: '30px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
    },
    titleBar: {
      padding: '5px 2px',
      width: '100%',
      borderRadius: '0',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },

    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    btnBox: {
      marginTop: '8px',
      display: 'flex',
      flexDirection: 'row-reverse',
      width: '100%',
      '@media (max-width: 480px)': {
        display: 'none',
        justifyContent: 'space-between',
        width: '100%',
      },
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },

    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    card: {
      minWidth: '195px',
      display: 'flex',
      background: '#fff',
      padding: '8px 4px',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    cardItem: {
      margin: '0 4px',
      flex: 1,
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#4BCF90',
      padding: '8px 24px 8px 50px',
      marginLeft: '-40px',
    },
    cards: {
      width: '100%',
      marginBottom: '14px',
      overflow: 'visible',
      padding: '14px 0 0',
      paddingBottom: '0',
    },

    cardContentOrder: {
      padding: '0',
    },
    cardContent: {
      marginTop: '-22px',
      display: 'flex',
    },
    cardContentlist: {
      justifyContent: 'space-between',
      padding: ' 0',
    },
  })
);

enum Type {
  skus = 'skus',
  warehouse = 'warehouse',
}

const ReturnedOrder: FunctionComponent<Props> = (props: Props) => {
  const authContext = useContext(AuthContext);
  const classes = useStyles();
  const { handleSubmit, errors, setValue, getValues, control } = useForm({
    defaultValues: {
      deliveryDate: null,
      deliveryTime: '',
    },
  });
  const values = getValues();
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 10,
    'status.equals': 'RETURNED',
  } as any);
  const [filters, setFilters] = useState([] as Filter[]);
  const [type, setType] = useState(Type.skus);
  const [numSelected, setNumSelected] = useState(0);
  const [variants, setVariants] = useState([]);
  const [variantsLoading, setVariantsLoading] = useState(false as boolean);
  const [ids, setIds] = useState([] as any);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const [isMob, setIsMob] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [menuValue, setMenuValue] = useState('');
  const { width } = windowSize();

  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const setupFilters = () => {
    Can({
      role: authContext.user.role,
      perform: 'orders:filtersByCenterId',
      yes: () => {
        setFilters([
          {
            type: 'input',
            id: 'customerName.contains',
            label: 'نام سفارش‌دهنده',
            icon: mdiAccountOutline,
          },
          {
            type: 'input',
            id: 'customerMobileNumber.contains',
            label: 'شماره همراه سفارش‌دهنده',
            icon: mdiPhoneOutline,
          },
          {
            type: 'input',
            id: 'id.equals',
            label: 'شناسه سفارش',
            icon: mdiPackageVariant,
          },

          {
            type: 'input',
            id: 'trackingCode.contains',
            label: 'کد پیگیری',
            icon: mdiPackageVariant,
          },
          {
            type: 'input',
            id: 'customerNationalCode.contains',
            label: 'کد  ملی',
            icon: mdiPackageVariant,
          },

          {
            type: 'input',
            id: 'centerName.contains',
            label: 'نام مرکز',
            icon: mdiHomeSearchOutline,
          },

          {
            type: 'input',
            id: 'customerProvinceName.contains',
            label: 'نام استان',
            icon: mdiHomeCityOutline,
          },
          {
            type: 'input',
            id: 'customerCity.contains',
            label: 'نام شهر',
            icon: mdiHomeCityOutline,
          },

          {
            type: 'date-picker-time',
            id: 'created.greaterThanOrEqual',
            label: 'تاریخ ثبت سفارش از ',
            icon: mdiCalendar,
          },
          {
            type: 'date-picker-time',
            id: 'created.lessThanOrEqual',
            label: 'تا تاریخ ثبت سفارش  ',
            icon: mdiCalendar,
          },
          {
            type: 'date-picker',
            id: 'deliveryDate.greaterThanOrEqual',
            label: 'تاریخ تحویل از ',
            icon: mdiCalendar,
          },
          {
            type: 'date-picker',
            id: 'deliveryDate.lessThanOrEqual',
            label: '  تا تاریخ تحویل ',
            icon: mdiCalendar,
          },
          {
            type: 'checkbox',
            id: 'status.in',
            label: 'وضعیت سفارش',
            icon: mdiStateMachine,
            data: [
              'ORDERED',
              'DELIVERED_TO_POST',
              'DELIVERED_TO_CENTER',
              'SUPPLIED_IN_CENTER',
              'PACKAGED',
              'BUNDLED',
              'LOADED',
              'ARRIVED',
              'DELIVERED',
              'NOT_DELIVERED',
              'RETURNED',
              'SUPPLYING',
              'CANCELLED',
            ],
            translateType: 'Order',
          },
          {
            type: 'checkbox',
            id: 'paymentType.in',
            label: 'شیوه پرداخت',
            icon: mdiStateMachine,
            data: [
              'COD', 'ONLINE'
            ],
            translateType: 'COD',
          },
        ]);
      },
      no: () => {
        setFilters([
          {
            type: 'input',
            id: 'customerName.contains',
            label: 'نام سفارش‌دهنده',
            icon: mdiAccountOutline,
          },
          {
            type: 'input',
            id: 'customerPhoneNumber.contains',
            label: 'شماره همراه سفارش‌دهنده',
            icon: mdiPhoneOutline,
          },
          {
            type: 'input',
            id: 'id.equals',
            label: 'شناسه سفارش',
            icon: mdiPackageVariant,
          },

          // {
          //   type: 'input',
          //   id: 'trackingCode.contains',
          //   label: 'شناسه پیگیری',
          // },

          {
            type: 'input',
            id: 'customerNationalCode.contains',
            label: 'کد  ملی',
            icon: mdiAccountKeyOutline,
          },
          // {
          //   type: 'input',
          //   id: 'centerProvince.contains',
          //   label: 'نام  استان',
          // },
          // {
          //   type: 'input',
          //   id: 'centerCity.contains',
          //   label: 'نام  شهر',
          // },

          // {
          //   type: 'date-picker-time',
          //   id: 'created.greaterThanOrEqual',
          //   label: 'تاریخ ثبت سفارش از ',

          // }, {
          //   type: 'date-picker-time',
          //   id: 'created.lessThanOrEqual',
          //   label: 'تا تاریخ ثبت سفارش  ',

          // },
          {
            type: 'date-picker',
            id: 'deliveryDate.greaterThanOrEqual',
            label: 'تاریخ تحویل از ',
            icon: mdiCalendar,
          },
          {
            type: 'date-picker',
            id: 'deliveryDate.lessThanOrEqual',
            label: '  تا تاریخ تحویل ',
            icon: mdiCalendar,
          },
          {
            type: 'checkbox',
            id: 'status.in',
            label: 'وضعیت سفارش',
            icon: mdiStateMachine,
            data: [
              'ORDERED',
              'DELIVERED_TO_POST',
              'DELIVERED_TO_CENTER',
              'SUPPLIED_IN_CENTER',
              'PACKAGED',
              'BUNDLED',
              'LOADED',
              'ARRIVED',
              'DELIVERED',
              'NOT_DELIVERED',
              'RETURNED',
              'SUPPLYING',
              'CANCELLED',
            ],
            translateType: 'Order',
          },
          {
            type: 'checkbox',
            id: 'paymentType.in',
            label: 'شیوه پرداخت',
            icon: mdiStateMachine,
            data: [
              'COD', 'ONLINE'
            ],
            translateType: 'COD',
          },
        ]);
      },
    });
  };

  const getAllVariantsCsv = async (actions: any) => {
    const payload = { ...actions, pagination: { page: 0, size: 10000 } };
    try {
      setVariantsLoading(true);
      const response = await skuRepository.getSkusInventory({
        payload,
      });
      setVariants(response.data.content);
    } catch (error) {
    } finally {
      setVariantsLoading(false);
    }
  };

  useEffect(() => {
    getOrders();
    setupFilters();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (ids.length) {
      const selectedItemsDetail = props.ordersList.filter(
        (order: SkuInventory) => ids.includes(order.id)
      );
      setSelectedItems(selectedItemsDetail);
    }
  }, [ids]);

  useEffect(() => {
    if (width && width <= 480) {
      setIsMob(true);
    } else {
      setIsMob(false);
    }
  }, [width]);

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const getOrders = () => {
    props.ordersDispatch({
      ...removeEmptyValueObject(filtersValues),
      noCount: true
    });
  };

  const handleClose = () => {
    setOpenSize(false);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  const handleMenuToggle = () => {
    setOpenMenu(prevOpen => !prevOpen);
  };
  const handleMenuClose = (event: Event | React.SyntheticEvent) => {
    const { myValue } = event.currentTarget.dataset;
    setMenuValue(myValue);
    setOpenMenu(false);
    setOpenModal(true);
  };
  const handleMenuCloseAway = (event: Event | React.SyntheticEvent) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }
  };
  const handleCloseReturnWarehouseModal = () => {
    setOpenModal(false);
    setMenuValue('');
  };
  const handleDeliveryDateChange = (date: any) => {
    setValue(
      'deliveryDate',
      convertPersianDigit2English(date.format('YYYY-MM-DD'))
    );
    setValue('deliveryTime', '');
  };
  const handleResendOrder = () => {
    let deliveryTime = getValues('deliveryTime');
    let deliveryDate = getValues('deliveryDate');
    if (deliveryDate.date) {
      deliveryDate = convertPersianDigit2English(
        deliveryDate.format('YYYY-MM-DD')
      );
    }
    if (!deliveryTime) {
      deliveryTime = '11-15';
    }
    const payload = {
      body: {
        deliveryDate,
        deliveryStartTime:
          props.ordersList.deliveryTypeValue !== 'VIP'
            ? convertPersianDigit2English(
              deliveryTime.substring(0, 2).concat(':00:00')
            )
            : `${('0' + new Date().getHours()).substr(-2)}:${(
              '0' + new Date().getMinutes()
            ).substr(-2)}`.concat(':00'),
        deliveryEndTime:
          props.ordersList.deliveryTypeValue !== 'VIP'
            ? convertPersianDigit2English(
              deliveryTime.substring(3, 5).concat(':00:00')
            )
            : `${('0' + (new Date().getHours() + 2)).substr(-2)}:${(
              '0' + new Date().getMinutes()
            ).substr(-2)}`.concat(':00'),
        orderIds: ids,
      },
    };
    props.resendOrdersDispatch(payload);
  };
  const handleReturnOrderToWarehouse = () => {
    const payload = {
      ids,
      status: 'REQUESTED_TO_RETURN',
      pagination: filtersValues,
    };
    props.updateAllOrderStatusDispatch(payload);
  };
  const numSelectHandler = (ids: [], num: number, id: number) => {
    const newSelectedItem = props.ordersList.filter(
      (order: SkuInventory) => id == order.id
    );
    const selectedItem = props.ordersList.filter(
      (order: SkuInventory) => ids[0] == order.id
    );
    if (
      newSelectedItem[0]?.deliveryDate == selectedItem[0]?.deliveryDate ||
      ids.length === 0
    ) {
      setNumSelected(num);
      setIds(ids);
    }
  };
  return (
    <div className={classes.root}>
      {/* <Grid
        style={{
          zIndex: 3,
          backgroundColor: 'white',
          position: 'fixed',
          top: '0',
          right: '71px',
        }}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={1}
          style={{
            padding: '5px 2px',
            width: '100%',
            borderRadius: '0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div className={classes.headerBox}>
          </div>
          <div
            style={{
              marginLeft: '140px',
            }}
          >
            <RenderFilter
              filters={filters}
              onFilter={(filtervalues: any) => {
                setFiltersValues({
                  ...removeEmptyValueObject(filtervalues),
                  page: 0,
                  size: 10,
                });
              }}
              mainFiltersCount={0}
              baseFilter={{
                type: 'input',
                id: 'trackingCode.contains',
                placeholder: 'کد پیگیری',
              }}
              filterValues={filtersValues}
            />
          </div>
        </Paper>
      </Grid> */}
      <Typography variant="h6" component="h2" style={{marginBottom: "24px"}}>
            {'سفارش های بازگردانده شده'}
          </Typography>
      <Grid container spacing={1} >
        <Card className={classes.cards}>
          <CardHeader
            avatar={
              <Grid>
                <Typography className={classes.typographyCards}>
                  لیست سفارش ها
                </Typography>
              </Grid>
            }
            action={
              <div className={classes.btnBox}>
                {/* <CSV
                    handleCreateCSV={getAllVariantsCsv}
                    data={variants}
                    filtersValues={{
                      page: 0,
                      size: 10000,
                    }}
                    loading={variantsLoading}
                  /> */}
                <ExelExport
                  data={variants}
                  loading={variantsLoading}
                  filtersValues={{
                    page: 0,
                    size: 10000,
                  }}
                  handleRequest={getAllVariantsCsv}
                />
                {numSelected >= 1 && (
                  <React.Fragment>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ marginLeft: '8px' }}
                      ref={anchorRef}
                      onClick={handleMenuToggle}
                      //   onClick={() => history.push('/create-grouping-inventory')}
                      size={
                        checkMatchMedia('(max-width: 1024px)')
                          ? 'small'
                          : 'large'
                      }
                      endIcon={<Icon path={mdiMenuDown} size={1} />}
                    >
                      {`تعیین وضعیت`}
                    </Button>
                    <Popper
                      open={openMenu}
                      anchorEl={anchorRef.current}
                      role={undefined}
                      placement="bottom-start"
                      transition
                      disablePortal
                      style={{ zIndex: '50' }}
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          {...TransitionProps}
                          style={{
                            transformOrigin:
                              placement === 'bottom-start'
                                ? 'left top'
                                : 'left bottom',
                          }}
                        >
                          <Paper
                            style={{ padding: '15px', position: 'absolute' }}
                          >
                            <ClickAwayListener
                              onClickAway={handleMenuCloseAway}
                            >
                              <MenuList
                                autoFocusItem={openMenu}
                                id="composition-menu"
                                aria-labelledby="composition-button"
                                // onKeyDown={handleListKeyDown}
                                // onClick={}
                                style={{ position: 'relative' }}
                              >
                                <MenuItem
                                  data-my-value={'RESEND'}
                                  onClick={handleMenuClose}
                                >
                                  ارسال مجدد
                                </MenuItem>
                                <MenuItem
                                  data-my-value={'RETURNED-TO-WAREHOUSE'}
                                  onClick={handleMenuClose}
                                >
                                  بازگشت به انبار
                                </MenuItem>
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </React.Fragment>
                )}
              </div>
            }
          />
          <CardContent className={classes.cardContentOrder}>
            <Grid container lg={12} md={12} className={classes.cardContentlist}>
              <Grid container item lg={12} md={12}>
                <Grid container item xs={12} md={12} lg={12}>
                  {props.loading ? (
                    <div className={classes.loading}>
                      <CircularProgress />
                    </div>
                  ) : (
                    <React.Fragment>
                      <Grid
                        container
                        item
                        xs={12}
                        justify="flex-end"
                        direction="row-reverse"
                        alignItems="center"
                        style={{ marginBottom: '20px' }}
                      >
                        <div className={classes.btnBox}>
                          <></>
                        </div>
                      </Grid>
                      <List
                        type={type}
                        handleNumSelect={numSelectHandler}
                        data={props.ordersList}
                        selected={ids}
                      />
                    </React.Fragment>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} style={{ padding: '20px 10px 0 10px' }}>
                  {props.ordersList.length > 0 && (
                    <FormControl
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                    >
                      <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                        {' '}
                        تعداد نمایش در هر صفحه:
                      </div>
                      <Select
                        open={openSize}
                        onClose={handleClose}
                        onOpen={() => setOpenSize(true)}
                        value={filtersValues.size}
                        onChange={handleChangeSizePage}
                      >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                </Grid>
                <Grid
                  xs={12}
                  sm={6}
                  container
                  item
                  direction="row-reverse"
                  style={{ padding: '20px 10px 0 10px' }}
                >
                  {props.ordersList.length > 0 && (
                    <Pagination
                      className={classes.pagination}
                      count={Math.ceil(props.count / filtersValues.size)}
                      color="secondary"
                      page={filtersValues.page + 1}
                      onChange={handleChangePage}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Dialog
        //   fullScreen
        onClose={handleCloseReturnWarehouseModal}
        // open={true}
        // fullWidthا
        maxWidth={'md'}
        open={openModal && menuValue == 'RETURNED-TO-WAREHOUSE'}
      // style={{minWidth:'80%',minHeight:'600px',maxWidth:'100%'}}
      >
        <DialogTitle>
          <div style={{ textAlign: 'right' }}>
            <span>{`آیا از بازگرداندن سفارش های زیر به انبار اطمینان دارید؟`}</span>
          </div>
          <div>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={handleCloseReturnWarehouseModal}
            >
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <ReturnList data={selectedItems} />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{ textAlign: 'left', marginBottom: '8px' }}
          >
            <Grid item xs={12}>
              <Button
                style={{ marginLeft: '8px' }}
                autoFocus
                onClick={handleCloseReturnWarehouseModal}
                variant="outlined"
                color="primary"
                size="large"
                data-cy="closeCancelation"
              >
                {`انصراف
`}
              </Button>
              <Button
                variant="contained"
                onClick={handleReturnOrderToWarehouse}
                //   disabled={!(cancelDescription.length > 0)}
                size="large"
                data-cy="submitCancelation"
                color="primary"
              >
                {`بازگشت به انبار`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        //   fullScreen
        onClose={handleCloseReturnWarehouseModal}
        // open={true}
        // fullWidthا
        maxWidth={'md'}
        open={openModal && menuValue == 'RESEND'}
      // style={{minWidth:'80%',minHeight:'600px',maxWidth:'100%'}}
      >
        <form onSubmit={handleSubmit(handleResendOrder)}>
          <DialogTitle>
            <div style={{ textAlign: 'right' }}>
              <span>{`در صورت اطمینان از ارسال مجدد سفارش های زیر، لطفا تاریخ و بازه جدید را انتخاب کنید:`}</span>
            </div>
            <div>
              <IconButton
                aria-label="close"
                className={classes.closeButton}
                onClick={handleCloseReturnWarehouseModal}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={3}>
              <Grid container item xs={12}>
                <Grid container item xs={12} sm={6} md={3} lg={3}>
                  <div className={classes.item}>
                    <div style={{ width: '100%' }} data-cy="deliveryDatePicker">
                      <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                        <Controller
                          rules={{ required: true }}
                          name="deliveryDate"
                          control={control}
                          as={
                            <DatePicker
                              inputVariant="outlined"
                              id="deliveryDate"
                              name="deliveryDate"
                              label="تاریخ تحویل سفارش"
                              format="jYYYY/jMM/jDD"
                              minDate={maxDate([
                                skipDateByDay(
                                  selectedItems[0]?.deliveryDate,
                                  2
                                ),
                                new Date(disablePrevDateByHour(16)),
                              ])}
                              fullWidth
                              disablePast
                              okLabel="تأیید"
                              cancelLabel="لغو"
                              defaultValue={null}
                              value={values.deliveryDate}
                              onChange={handleDeliveryDateChange}
                              error={errors.hasOwnProperty('deliveryDate')}
                              helperText={
                                errors.deliveryDate &&
                                errors.deliveryDate.message
                              }
                            />
                          }
                        />
                        <FormHelperText error focused>
                          {errors.deliveryDate &&
                            'تاریخ تحویل سفارش الزامی میباشد'}
                        </FormHelperText>
                      </MuiPickersUtilsProvider>
                    </div>
                  </div>
                </Grid>
                <Grid container item xs={12} sm={6} md={3} lg={3}>
                  <div style={{ width: '100%' }} className={classes.item}>
                    <div style={{ width: '100%' }} data-cy="deliveryTimePicker">
                      <Controller
                        rules={{ required: true }}
                        style={{ width: '100%' }}
                        control={control}
                        name="deliveryTime"
                        label="بازه تحویل سفارش"
                        as={
                          <TextField
                            variant="outlined"
                            select
                            fullWidth
                            // disabled={deliveryTypeValue === ''}
                            error={
                              !!errors.deliveryTime && !!errors.deliveryTime
                            }
                          >
                            <MenuItem
                              // disabled={handleDisableTime(11)}
                              value={'11-15'}
                              data-cy="firstTime"
                            >
                              {'11 الی 15'}
                            </MenuItem>
                            <MenuItem
                              // disabled={handleDisableTime(16)}
                              value={'16-20'}
                              data-cy="secondTime"
                            >
                              {'16 الی 20'}
                            </MenuItem>
                          </TextField>
                        }
                      />
                      <FormHelperText error focused>
                        {errors?.deliveryTime &&
                          ' بازه تحویل سفارش الزامی میباشد'}
                      </FormHelperText>
                    </div>
                  </div>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <ResendList data={selectedItems} />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              style={{ textAlign: 'left', marginBottom: '8px' }}
            >
              <Grid item xs={12}>
                <Button
                  style={{ marginLeft: '8px' }}
                  autoFocus
                  onClick={handleCloseReturnWarehouseModal}
                  variant="outlined"
                  color="primary"
                  size="large"
                  data-cy="closeCancelation"
                >
                  {`انصراف
`}
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  size="large"
                  data-cy="submitCancelation"
                  color="primary"
                >
                  {`ارسال مجدد`}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  ordersList: makeSelectOrdersList(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    ordersDispatch: (payload: Payload) => dispatch(getOrdersAction(payload)),
    allOrdersDispatch: (payload: Payload) =>
      dispatch(getAllOrdersReportAction(payload)),
    updateOrderStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
    }) => dispatch(updateOrderStatusActions(payload)),
    updateAllOrderStatusDispatch: (payload: PayloadAllUpdate) =>
      dispatch(updateAllOrderStatusActions(payload)),
    actionRetrieveRubikaOrdersDispatch: (payload: {
      date?: String;
      from?: number;
      to?: number;
    }) => dispatch(actionRetrieveRubikaOrdersAction(payload)),
    cancelOrderDispatch: (payload: cancelPayload) =>
      dispatch(cancelOrderAction(payload)),
    resendOrdersDispatch: (payload: cancelPayload) =>
      dispatch(resendOrdersAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
// @ts-ignore
export default compose(withConnect)(ReturnedOrder);
